/* smellBgone — scroll-position dots for horizontal card carousels.

   Liquid port of app/components/ScrollDots.tsx. Each [data-scroll-dots] element
   attaches to its immediately preceding sibling (the scroll container), renders
   one dot per card, and lights every card substantially in view. When the row
   fits without scrolling (desktop / <2 cards) nothing shows. Decorative — the
   row itself is the labelled, keyboard-reachable scroll region, so the dots are
   aria-hidden and are not buttons. */
(function () {
  if (window.__smbScrollDotsInit) return;
  window.__smbScrollDotsInit = true;

  function wire(host) {
    var el = host.previousElementSibling;
    if (!el) return;

    function update() {
      var cards = Array.prototype.slice.call(el.children);
      if (cards.length < 2 || el.scrollWidth <= el.clientWidth + 1) {
        host.removeAttribute('data-active');
        host.innerHTML = '';
        return;
      }
      var box = el.getBoundingClientRect();
      var shown = [];
      var bestFit = 0;
      var mostVisible = -1;
      cards.forEach(function (card, i) {
        var r = card.getBoundingClientRect();
        var overlap = Math.min(r.right, box.right) - Math.max(r.left, box.left);
        var ratio = r.width > 0 ? overlap / r.width : 0;
        if (ratio > mostVisible) {
          mostVisible = ratio;
          bestFit = i;
        }
        if (ratio >= 0.6) shown.push(i);
      });
      if (!shown.length) shown = [bestFit];

      // Rebuild only when the dot count changes; otherwise just retoggle.
      if (host.children.length !== cards.length) {
        host.innerHTML = '';
        for (var i = 0; i < cards.length; i++) {
          var dot = document.createElement('span');
          dot.className = 'smb-scroll-dots-dot';
          host.appendChild(dot);
        }
      }
      Array.prototype.forEach.call(host.children, function (dot, i) {
        if (shown.indexOf(i) !== -1) dot.setAttribute('data-current', '');
        else dot.removeAttribute('data-current');
      });
      host.setAttribute('data-active', '');
    }

    update();
    el.addEventListener('scroll', update, { passive: true });
    if (typeof ResizeObserver !== 'undefined') {
      var ro = new ResizeObserver(update);
      ro.observe(el);
      Array.prototype.forEach.call(el.children, function (c) {
        ro.observe(c);
      });
    } else {
      window.addEventListener('resize', update);
    }
  }

  function init() {
    document.querySelectorAll('[data-scroll-dots]').forEach(wire);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
